import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import ImageUploadField from "../../../utils/ImageUploadField";
import { confirmDelete, successToast } from "../../../utils/dialog";

export default function AdminVillaGallery() {
  const { villaVideos, addVillaVideo, updateVillaVideo, deleteVillaVideo } = useData();
  console.log("Villa Videos", villaVideos);

  const [newVideo, setNewVideo] = useState({
    title: "",
    src: "",
  });

  const [file, setFile] = useState(null); // File for upload
  const [editingVideo, setEditingVideo] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewVideo((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]); // Set the selected file
  };

  const handleAddVideo = async () => {
    if (newVideo.title) {
      await addVillaVideo(newVideo, file); // Pass the file to the method
      setNewVideo({ title: "", src: "" });
      setFile(null); // Reset the file input
    }
  };

  const handleUpdateVideo = async () => {
    if (editingVideo && newVideo.title) {
      await updateVillaVideo(editingVideo.id, newVideo, file); // Pass the file to the method
      setEditingVideo(null);
      setNewVideo({ title: "", src: "" });
      setFile(null); // Reset the file input
    }
  };

  const handleEdit = (video) => {
    setEditingVideo(video);
    setNewVideo({ title: video.title, src: video.src });
  };

  const handleDelete = async (id) => {
    if (
      await confirmDelete({
        title: "Delete Video?",
        text: "This video will be permanently deleted.",
      })
    ) {
      await deleteVillaVideo(id);
      successToast("Video deleted successfully.");
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Manage Villa In Motion Gallery</h2>

      {/* Add/Edit Form */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold mb-2">{editingVideo ? "Edit Video" : "Add New YouTube Short"}</h3>
        <input
          type="text"
          name="title"
          placeholder="Title"
          value={newVideo.title}
          onChange={handleInputChange}
          className="block w-full mb-2 p-2 border rounded"
        />
        <input
          type="text"
          name="src"
          placeholder="YouTube Shorts URL (e.g., https://www.youtube.com/shorts/hVvsiP3KqW8)"
          value={newVideo.src}
          onChange={handleInputChange}
          className="block w-full mb-4 p-2 border rounded"
        />
        <button
          onClick={editingVideo ? handleUpdateVideo : handleAddVideo}
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          {editingVideo ? "Update Video" : "Add Video"}
        </button>
        {editingVideo && (
          <button
            onClick={() => {
              setEditingVideo(null);
              setNewVideo({ title: "", src: "" });
            }}
            className="ml-2 px-4 py-2 bg-gray-500 text-white rounded"
          >
            Cancel
          </button>
        )}
      </div>

      {/* Video List */}
      <div>
        <h3 className="text-xl font-semibold mb-2">Videos</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {villaVideos.map((video) => {
            // Convert shorts URL to embed URL if needed
            let embedUrl = video.src;
            if (video.src.includes("youtube.com/shorts/")) {
              embedUrl = video.src.replace("youtube.com/shorts/", "youtube.com/embed/");
            }

            return (
              <div key={video.id} className="p-4 border rounded shadow flex flex-col">
                <div className="aspect-[9/16] w-full bg-black mb-2 overflow-hidden rounded-lg">
                  <iframe
                    src={embedUrl}
                    title={video.title}
                    className="w-full h-full"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <h4 className="text-lg font-bold flex-grow">{video.title}</h4>
                <div className="mt-4 flex justify-between">
                  <button
                    onClick={() => handleEdit(video)}
                    className="px-3 py-1 bg-yellow-500 text-white rounded"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(video.id)}
                    className="px-3 py-1 bg-red-500 text-white rounded"
                  >
                    Delete
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}